import type { FC, ReactNode } from 'react';

import { Image } from '@sravni/react-image';

interface IOptimizedPicture {
  img: ReactNode;
  alt: string;
  width?: number;
  height?: number;
  imgClassName?: string | undefined;
  className?: string;
}

export const OptimizedPicture: FC<IOptimizedPicture> = ({ className, img, alt, width, height, imgClassName }) => (
  <div className={className}>
    <Image className={imgClassName} src={img as string} height={height} width={width} alt={alt} />
  </div>
);
